var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=visibility_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.465088,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility_off",
    d: "M16.1 13.7651L14.65 12.3151C14.8 11.5318 14.575 10.7985 13.975 10.1151C13.375 9.4318 12.6 9.16514 11.65 9.31514L10.2 7.86514C10.4833 7.7318 10.7708 7.6318 11.0625 7.56514C11.3542 7.49847 11.6667 7.46514 12 7.46514C13.25 7.46514 14.3125 7.90264 15.1875 8.77764C16.0625 9.65264 16.5 10.7151 16.5 11.9651C16.5 12.2985 16.4667 12.611 16.4 12.9026C16.3333 13.1943 16.2333 13.4818 16.1 13.7651ZM19.3 16.9151L17.85 15.5151C18.4833 15.0318 19.0458 14.5026 19.5375 13.9276C20.0292 13.3526 20.45 12.6985 20.8 11.9651C19.9667 10.2818 18.7708 8.9443 17.2125 7.95264C15.6542 6.96097 13.9167 6.46514 12 6.46514C11.5167 6.46514 11.0417 6.49847 10.575 6.56514C10.1083 6.6318 9.65 6.7318 9.2 6.86514L7.65 5.31514C8.33333 5.0318 9.03333 4.8193 9.75 4.67764C10.4667 4.53597 11.2167 4.46514 12 4.46514C14.5167 4.46514 16.7583 5.16097 18.725 6.55264C20.6917 7.9443 22.1167 9.74847 23 11.9651C22.6167 12.9485 22.1125 13.861 21.4875 14.7026C20.8625 15.5443 20.1333 16.2818 19.3 16.9151ZM19.8 23.0651L15.6 18.9151C15.0167 19.0985 14.4292 19.236 13.8375 19.3276C13.2458 19.4193 12.6333 19.4651 12 19.4651C9.48333 19.4651 7.24167 18.7693 5.275 17.3776C3.30833 15.986 1.88333 14.1818 1 11.9651C1.35 11.0818 1.79167 10.261 2.325 9.50264C2.85833 8.7443 3.46667 8.06514 4.15 7.46514L1.4 4.66514L2.8 3.26514L21.2 21.6651L19.8 23.0651ZM5.55 8.86514C5.06667 9.29847 4.625 9.77347 4.225 10.2901C3.825 10.8068 3.48333 11.3651 3.2 11.9651C4.03333 13.6485 5.22917 14.986 6.7875 15.9776C8.34583 16.9693 10.0833 17.4651 12 17.4651C12.3333 17.4651 12.6583 17.4443 12.975 17.4026C13.2917 17.361 13.6167 17.3151 13.95 17.2651L13.05 16.3151C12.8667 16.3651 12.6917 16.4026 12.525 16.4276C12.3583 16.4526 12.1833 16.4651 12 16.4651C10.75 16.4651 9.6875 16.0276 8.8125 15.1526C7.9375 14.2776 7.5 13.2151 7.5 11.9651C7.5 11.7818 7.5125 11.6068 7.5375 11.4401C7.5625 11.2735 7.6 11.0985 7.65 10.9151L5.55 8.86514Z",
    fill: "#1C1D1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordClosed);
export default __webpack_public_path__ + "static/media/PasswordClosed.2d5f9f428a3ce5699dcb49651be91ca7.svg";
export { ForwardRef as ReactComponent };